enum UserType {
  Office,
  User,
  Manager,
  Admin
}

export default UserType;
